
import { MapTo } from '@adobe/aem-react-editable-components';
import AppBulletList, { AppBulletListEditConfig } from './AppBulletList';

export default MapTo('cob-corp-acquisition/components/creditonebank/app-bullet-list')(AppBulletList, AppBulletListEditConfig);
        